import {
  Button,
  Inline,
  Modal,
  type ModalProps,
  notifySuccess,
} from '@omnipresentgroup/design-system';
import { useRequestLiabilityShield } from '@omnipresentgroup/domains';
import type { Contractor } from '@omnipresentgroup/types';
import { useEffect } from 'react';

import { ContractorLiabilityShieldDescription } from './ContractorLiabilityShieldDescription';

const MODAL_TITLE = 'Omniprotect';

type Props = {
  modalProps: Omit<ModalProps, 'children'>;
  contractor?: Contractor;
  handleClose: () => void;
};

export const ContractorLiabilityShieldModal = (props: Props) => {
  const { modalProps, contractor, handleClose } = props;

  const {
    mutate: requestLiabilityShield,
    isPending,
    isSuccess,
    isError,
    reset,
  } = useRequestLiabilityShield();

  useEffect(() => {
    if (isSuccess) {
      notifySuccess({
        title: 'The interest in Omniprotect has been successfully registered',
      });
    }
    if (isSuccess || isError) {
      reset();
      handleClose();
    }
  }, [handleClose, isError, isSuccess, reset]);

  return (
    <Modal {...modalProps} span={4}>
      <Modal.Header title={MODAL_TITLE} />

      <Modal.Body>
        <ContractorLiabilityShieldDescription />
      </Modal.Body>

      <Modal.Footer>
        <Inline justify="space-between" w="stretch" align="center">
          <Button variant="secondary" onClick={() => handleClose()}>
            Cancel
          </Button>
          <Button
            variant="primary"
            loading={isPending}
            onClick={() =>
              requestLiabilityShield({ contractorId: contractor?.id })
            }
          >
            Register interest
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
